module.exports = __webpack_public_path__ + "static/media/web.f4b8238b.jpg";